import { motion } from "framer-motion";

export const ChapterHeading = ({ number, title, italic, testId }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
    className="mb-16 md:mb-20"
    data-testid={testId}
  >
    <div className="mb-6 flex items-center gap-6">
      <span className="font-display text-sm italic text-gold">{number}</span>
      <span className="gold-rule flex-1" aria-hidden="true" />
    </div>
    <h2 className="font-display text-4xl font-light tracking-tight text-[#F5F5F0] md:text-6xl">
      {title} <em className="text-gold">{italic}</em>
    </h2>
  </motion.div>
);
